/**
 * Pulsar PoE switch catalog — Polish manufacturer specialising in
 * CCTV-dedicated network infrastructure (power supplies, enclosures,
 * PoE switches). Their SFG / ISFG lines are popular in Polish CCTV
 * installs as they ship as ready-to-deploy kits + accept Pulsar's
 * own redundant DC power supplies.
 *
 * Verified against pulsar.pl product pages.
 *
 * Compiled: 2026-05-15, release/v1.6.7-23k-catalog.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const PULSAR_POE_SWITCHES: EquipmentCatalogEntry[] = [
  // ═══════════════════════════════════════════════════════════════════════
  // SFG series — desktop / cabinet AC-powered
  // ═══════════════════════════════════════════════════════════════════════

  // SRC: https://www.pulsar.pl/EN_120_SFG108-90W_sfg108-90w-12-port-poe-switch-for-8-ip-cameras
  //      SFG108-90W: 12 total ports = 8× PoE 1 Gb/s + 2× RJ45 1 Gb/s
  //      uplink (TP/9, TP/10) + 2× SFP 1 Gb/s uplink (SFP/11, SFP/12).
  //      IEEE 802.3af/at PoE+, 80 W total budget across all PoE ports,
  //      30 W max per port. 100-240 V AC input.
  {
    id: 'pulsar-sfg108-90w',
    manufacturer: 'Pulsar',
    model: 'SFG108-90W',
    category: 'poe-switch',
    tagline:
      'SFG108-90W — 12-port (8× PoE GbE + 2× RJ45 + 2× SFP uplinks), 80 W budget, 802.3at',
    verified: true,
    datasheetUrl: 'https://www.pulsar.pl/EN_120_SFG108-90W_sfg108-90w-12-port-poe-switch-for-8-ip-cameras',
    specs: {
      totalPorts: 12,
      poePorts: 8,
      poeBudgetW: 80,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2× RJ45 GbE + 2× SFP GbE',
      management: 'unmanaged',
      formFactor: 'desktop',
    },
  },

  // ═══════════════════════════════════════════════════════════════════════
  // ISFG series — industrial DIN-rail DC-powered
  // ═══════════════════════════════════════════════════════════════════════

  // SRC: https://www.pulsar.pl/EN_167_ISFG108_industrial-poe-switch-isfg108-(8xpoe,-2xsfp,-2xrj45)
  //      ISFG108: industrial DIN-rail variant of the SFG line. 12 total
  //      ports = 8× PoE 1 Gb/s + 2× RJ45 1 Gb/s uplink + 2× SFP 1 Gb/s
  //      uplink. IEEE 802.3af/at PoE+, 30 W max per port, 120 W total
  //      budget. 12-57 V DC input with redundant supply option (Pulsar
  //      recommends NDR-120-48 PSU). DIN-rail 54 × 176 × 153 mm,
  //      5-year warranty.
  {
    id: 'pulsar-isfg108',
    manufacturer: 'Pulsar',
    model: 'ISFG108',
    category: 'poe-switch',
    tagline:
      'ISFG108 — industrial DIN GbE PoE switch, 8 PoE + 4 uplinks, 120 W, 12-57 V DC redundant',
    verified: true,
    datasheetUrl:
      'https://www.pulsar.pl/EN_167_ISFG108_industrial-poe-switch-isfg108-(8xpoe,-2xsfp,-2xrj45)',
    specs: {
      totalPorts: 12,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2× RJ45 GbE + 2× SFP GbE',
      management: 'unmanaged',
      formFactor: 'industrial-DIN',
    },
  },
];
